<script lang="ts">
  // Localization
  import { _ } from 'svelte-i18n'
  import type { Readable } from 'svelte/store';
  import type { Writable } from 'svelte/store';
  import { getDiamondFromDifficulty, containsQuery, playSessionNow, copyTemplate, copyInstance, parseStorage } from './Util/utils';
  import { getContext } from 'svelte';

	import { flip } from 'svelte/animate';
  import { quadInOut,  } from 'svelte/easing';

  import { createEventDispatcher } from 'svelte';

  import Select from 'svelte-select';

  import ExerciseCard from './ExerciseCard/ExerciseCard.svelte';
  import FilterModal from './FilterModal.svelte';

  export let loading_sessions;
  export let error_loading_sessions;
  export let reloadSessions;

  export let templates_promise: Promise<any>;

  export let joinSession;
  export let createNewSession;
  
  export let allowedToEdit;
  export let allowedToReschedule;
  export let hide_template_browser = false;
  export let hide_tabs = false;

  // Modal related stuff
  let hasFilter: boolean;

  let searchBox: string;
  const filterKey = 'sessionsFilter'
  let searchQuery: string = parseStorage(filterKey).searchBox ?? '';
  let minDuration: number;
  let maxDuration: number;
  let minXSS: number;
  let maxXSS: number;
  let selectedFocus;
  let selectedSpecificity;
  let minDiamonds;
  let maxDiamonds;

  let templates: Writable<any[]> = getContext('sessionTemplates');
  let displayTemplates;
  
  $: {
    let sortedTemplates = $templates;

    // Filter by duration
    if(minDuration || maxDuration) sortedTemplates = sortedTemplates.filter(workout => (!minDuration || workout.duration/60 >= minDuration) && (!maxDuration || workout.duration/60 <= maxDuration));

    // Filter by XSS
    if(minXSS || maxXSS) sortedTemplates = sortedTemplates.filter(workout => (!minXSS || workout.xss >= minXSS) && (!maxXSS || workout.xss <= maxXSS));

    // Filter by focus
    let focuses = ["", "Power Sprinter", "Road Sprinter", "Pursuiter", "Puncheur", "Breakaway Specialist", "Rouleur", "GC Specialist", "Climber", "Endurance"];
    if(selectedFocus && selectedFocus.value != 0) sortedTemplates = sortedTemplates.filter(workout => workout.focus == focuses[selectedFocus.value]);

    // Filter by specificity
    let specificity = ['', 'Pure', 'Mixed', 'Polar']
    if (selectedSpecificity && selectedSpecificity.value != 0) sortedTemplates = sortedTemplates.filter((workout) => workout.specRating == specificity[selectedSpecificity.value]);

    // Filter by difficulty
    if(minDiamonds || maxDiamonds) sortedTemplates = sortedTemplates.filter(workout => (!minDiamonds || getDiamondFromDifficulty(workout.difficulty) > (minDiamonds.value+2)/2) && (!maxDiamonds || getDiamondFromDifficulty(workout.difficulty) <= (maxDiamonds.value+2)/2));

    // Apply Search Query
    let queryArray = searchQuery.match(/("[^"]+")|([^ ]+)/g);
    //split the query by spaces, but ignore spaces if surrounded by quotes
    if(queryArray !== null && queryArray.length !== 0){
        queryArray.forEach((q) => {
            if(q.at(0) === '"'){
                //check to see if it starts with a quote, as the splitting process leaves surrounding quotes in
                q = q.replace(/"(.)*"/, q.substring(1, q.length-1));
            }
            sortedTemplates = sortedTemplates.filter(workout => containsQuery(workout, q));
        });
    }

    displayTemplates = sortedTemplates;
    
  }

	const dispatch = createEventDispatcher();

  let session_type_items = [
    { label: $_("sessions.browser.upcoming"), value: 0, },
    { label: $_("sessions.browser.recent"), value: 1, },
    { label: $_("sessions.browser.archived"), value: 2, },
  ];
  let selected_session_type = session_type_items[0];
  let selected_session_list = [];
  $: if (selected_session_type.value > 0) {
    dispatch('loadsessions', {
			value: selected_session_type.value,
      when: new Date()
		});
  }
  let now;
  let recent;
  let react_to_sessions = (sessions, selected_session_type) => {
    now = Date.now();
    recent = now - 7*24*3600*1000;
    switch(selected_session_type.value) {
      case 0:
        selected_session_list = sessions.filter(s=>(new Date(s.end_date).getTime()) > Date.now())
        break;
      case 1:
        selected_session_list = sessions.filter(s=>{
            const t = new Date(s.end_date).getTime()
            return t <= now && t > recent
        }).reverse()
        break;
      case 2:
        selected_session_list = sessions.filter(s=>(new Date(s.end_date).getTime()) <= recent).reverse()
        break;
    }
  }
  $: react_to_sessions($sessions, selected_session_type)

  let show_templates = true;
  export function showSessionInstances() {
    show_templates = false;
  }

  let template_type_items = [
    { label: $_("sessions.browser.personal"), value: 2, },
    { label: $_("sessions.browser.community"), value: 1, },
    { label: $_("sessions.browser.standard"), value: 0, },
  ];

  let selected_template_type = template_type_items[2];
  $: session_type_to_show = selected_template_type.value;
  
  $: session_templates_personal = [];
  $: session_templates_community = [];
  $: session_templates_standard = [];
  $: {
    
    session_templates_personal = displayTemplates.filter(s=>s.session_type == "Personal");
    session_templates_community = displayTemplates.filter(s=>s.session_type == "Community");
    session_templates_standard = displayTemplates.filter(s=>s.session_type == "Standard");

  }

  function alphaSort(a, b) {
    let nameA = a.name.toLowerCase();
    let nameB = b.name.toLowerCase();
    if(nameA < nameB) { return -1; }
    if(nameA > nameB) { return 1; }
    return 0;
  }

  // Organize community sessions by their owner_community.
  let session_templates_by_community = [];

  let clubs: Writable<[any]> = getContext('all_clubs');

  $: if($clubs != null) {
    let communities = [];
    let stbc = new Map();
    let stbc_arr = [];

    // Find all unique communities in the sessions in store.
    session_templates_community.forEach(s => {
      let community = s.owner_community;
      if(!communities.includes(community)) {
        communities.push(community);
      }
    });
    // For each unique community, find all sessions owned by it
    // and put the group in a map with the club as key.
    if(communities.length != 0) {
      communities.forEach(c => {
        let sessions_by_community = [];
        session_templates_community.forEach(s => {
          if(s.owner_community == c) {
            sessions_by_community.push(s);
          }
        });
        let club = $clubs.find(v=>v.id == c);
        if(club != null) {
          stbc.set(club.display_name, sessions_by_community);
        }
      });
      // Sort result.
      let stbcSorted = new Map([...stbc].sort());
      // Put map into array which can be traversed.
      stbcSorted.forEach((c, s) => {
        stbc_arr.push({community: s, sessions: c});
      });
    }
    session_templates_by_community = stbc_arr;
  }

  let sessions: Readable<any[]> = getContext('sessions');
  $: all_sessions = $sessions;

  let params: Writable<any> = getContext("user_params");

</script>


{#if !hide_tabs}
<ul class="nav nav-tabs nav-tabs-style override-tab-styles" style="margin-bottom: 24px;">
  {#if $params.premium && !hide_template_browser}
  <li class="tab-button" class:active={show_templates} on:click={()=>show_templates = true}><a>{$_("sessions.browser.sessionslibrary")}</a></li>
  <li class="tab-button" class:active={!show_templates} on:click={()=>show_templates = false}><a>{$_("sessions.browser.sessionsscheduled")}</a></li>
  {/if}
  <spacer/>
  <slot name="tabs"></slot>
  
</ul>
{/if}
<browser>
  {#if show_templates && $params.premium && !hide_template_browser}
    <flex-container class="my-input grid-outline">
      <h3>
        {$_("sessions.browser.sessionslibrary")}
      </h3>
      <spacer/>
      <div>
        <Select isClearable={false} bind:value={selected_template_type} items={template_type_items} showIndicator={true} indicatorSvg={'<i class="fa fa-angle-down" style="color: var(--color-xert-gray); top: 0px; height: 100%; line-height: var(--height);"/>'}/>
      </div>
      <button class="btn btn-default btn-session" on:auxclick={createNewSession}
        on:click={createNewSession}>
        {$_("sessions.editor.create_session")}
      </button>
      <FilterModal {filterKey} onApply={()=>{searchQuery = searchBox;}} title="Filter Sessions" bind:hasFilter={hasFilter}
        bind:searchBox={searchBox} bind:minDuration={minDuration} bind:maxDuration={maxDuration} bind:minXSS={minXSS} bind:maxXSS={maxXSS} bind:selectedFocus bind:selectedSpecificity bind:minDiamonds={minDiamonds} bind:maxDiamonds={maxDiamonds}/>
    </flex-container>
    {#if session_type_to_show == 0}
      <flex-container>
      {#each session_templates_standard as template (template.template_id)}
        <div animate:flip="{{duration:d=>30*Math.sqrt(d), easing: quadInOut}}">
          <ExerciseCard exerciseType="Session" {...template} playSessionNow={()=>playSessionNow(template)} allowed_to_edit={allowedToEdit(template)} copySession={()=>copyTemplate(template)}/>
        </div>
      {/each}
      </flex-container>
    {:else if session_type_to_show == 1}
      {#each session_templates_by_community as {community, sessions}}
        <h3>{community}</h3>
        <flex-container>
          {#each sessions as template (template.template_id)}
            <div animate:flip="{{duration:d=>30*Math.sqrt(d), easing: quadInOut}}">
              <ExerciseCard exerciseType="Session" {...template} playSessionNow={()=>playSessionNow(template)} allowed_to_edit={allowedToEdit(template)} copySession={()=>copyTemplate(template)}/>
            </div>
          {/each}
        </flex-container>
      {/each}
    {:else if session_type_to_show == 2}
      <flex-container>
      {#each session_templates_personal as template (template.template_id)}
        <div animate:flip="{{duration:d=>30*Math.sqrt(d), easing: quadInOut}}">
          <ExerciseCard exerciseType="Session" {...template} playSessionNow={()=>playSessionNow(template)} allowed_to_edit={allowedToEdit(template)} copySession={()=>copyTemplate(template)}/>
        </div>
      {/each}
      </flex-container>
    {:else}
      {"Exception: unknown session type"}
    {/if}
    {#await templates_promise}
    <flex-container style="justify-content: center; padding-top: 48px;">
      <div style="color: var(--color-xert-teal); font-size: 32px; flex: 0 0 0;" class="fas fa-circle-notch fa-spin"/>
    </flex-container>
    {/await}
  {:else}
    {#if !hide_tabs}
    <flex-container class="my-input grid-outline">
      <h3>
        {$_("sessions.browser.sessionsscheduled")}
      </h3>
      <spacer/>
      <div>
        <Select isClearable={false} bind:value={selected_session_type} items={session_type_items} showIndicator={true} indicatorSvg={'<i class="fa fa-angle-down" style="color: var(--color-xert-gray); top: 0px; height: 100%; line-height: var(--height);"/>'} />
      </div>
    </flex-container>
    {/if}

    {#each selected_session_list as session (session.session_id)}
      <div animate:flip="{{duration:d=>30*Math.sqrt(d), easing: quadInOut}}">
        <ExerciseCard exerciseType="Session" copySession={$params.premium ? ()=>copyInstance(session) : null} allowed_to_edit={allowedToReschedule(session)} {joinSession} {...session}/>
        <br/>
      </div>
    {/each}
    {#if loading_sessions}
    <flex-container style="justify-content: center; padding-top: 48px;">
      <div style="color: var(--color-xert-teal); font-size: 32px; flex: 0 0 0;" class="fas fa-circle-notch fa-spin"/>
    </flex-container>
    {/if}
    {#if error_loading_sessions}
    <flex-container style="justify-content: center; padding-top: 48px;">
      <button class="btn btn-default btn-session" on:click={reloadSessions}>
        <!--i class="fa fa-file-o" data-placement="left"></i-->
        {$_("sessions.browser.retry")}
      </button>
    </flex-container>
    {/if}
  {/if}
</browser>


<style lang="scss">
  // media-size-md used in coarse-grid defined in style/xert.scss
  // Increase this width to 2x the min desired width of the session card.
  // NOTE: Define this var before xert.scss is imported to override defaults.
  $media-size-md: 1100px;

  @import './style/xert.scss';
	coarse-grid {
		//text-align: center;
		margin: 0 auto;
    grid-auto-flow: dense;
    > rcontainer.col {

      grid-column-start: 2;
      @media(max-width: $media-size-md) {
        grid-column-start: unset;
      }
    }
	}

  ul.nav-tabs {
    display: flex;
    border-bottom: 1px solid #ECECEC;
    width: 100%;
    padding: 0px;
    margin: 0 0 24px 0;
    min-height: 40px;
    flex-wrap: wrap-reverse;
    > .tab-button {
      flex: 1 1 140px;
    }
  }
  flex-container {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;

    &.my-input {
      > h3 {
        margin: 0px;
      }
      padding: 15px 26px 15px 26px;
      margin-bottom: 24px;

      align-items: center;

      // Vars for Select component
      >div {
        flex: 0 0 131px;
      }
      @include medium-text;
      --fontSize: 16px;
      --height: 30px;
      --padding: 0 12px !important;
      --itemColor: var(--color-xert-gray-text);
      --border: 1px solid var(--color-xert-gray);
      --borderFocusColor: var(--color-xert-gray);
      --borderHoverColor: var(--color-xert-blue);
      --borderRadius: 3px !important;
      --listBorder: 1px solid var(--color-xert-blue);

      --indicatorRight: 20px;
      --indicatorTop: 0;
      --indicatorHeight: 0;
      --indicatorWidth: 0;

      > button, > button:focus {
        @include medium-text;
        border-radius: var(--borderRadius) !important;
        background-color: white;
        border: var(--border) !important;
        height: 30px;
      }

      > button:hover, > button:active {
        border-color: var(--borderHoverColor) !important;
        background-color: white;
      }
    }

    > div {
      //flex-basis: 240px;
      max-width: 100%;
      //height: 200px;
      flex: 1 1 100%;
    }
  }
  button.btn-session {
    overflow: unset; // Unset overflow:none; from metronic/bootstrap theme to allow button to expand to fit text.
  }
</style>
